import { render, staticRenderFns } from "./PersonContact.vue?vue&type=template&id=76edcd56&scoped=true&"
import script from "./PersonContact.vue?vue&type=script&lang=js&"
export * from "./PersonContact.vue?vue&type=script&lang=js&"
import style0 from "@/assets/styles/beneficiary.css?vue&type=style&index=0&id=76edcd56&prod&scoped=true&lang=css&"
import style1 from "./PersonContact.vue?vue&type=style&index=1&id=76edcd56&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76edcd56",
  null
  
)

export default component.exports